import api from '../../../../App/socket';

export const createUserPhone = (user_id, name, phone) => (
    api.send({
        api: 'db',
        model: 'User',
        action: 'NestedCreate',
        options: {
            create: { name, phone },
            where: {
                _id: user_id,
            },
            fullPath: 'person.phones',
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/user_phones_requests/create_user_phone_request.js